
import BrandsFilterDrawer, { BrandsFilterTrigger } from "./components/brands-filter-drawer";
import Datatable from "@components/datatable";
import useBrands from "./hooks/use-brands";
import { BRANDS_COLUMNS } from "./misc/columns";

const Brands = () => {
    const {
        rows, pagination, loading,
        filters, activeFilterCount, handleFilterChange,
        filterOpen, openFilters, closeFilters,
        handlePageChange, handlePerRowsChange
    } = useBrands();

    return (
        <div className="p-6">
            <div className="flex items-start justify-between">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">Brands</h1>
                    <p className="text-sm text-muted">{pagination.total} brand(s) on Nook Pay.</p>
                </div>
                <div className="flex items-center gap-3">
                    <BrandsFilterTrigger activeCount={activeFilterCount} onClick={openFilters} />
                    {/* <Link
                        to="/brands/new"
                        className="inline-flex h-10 items-center gap-2 rounded-lg bg-primary px-4 text-sm font-medium text-white shadow transition-colors hover:bg-primary/90">
                        <Plus className="h-4 w-4" />
                        Onboard new brand
                    </Link> */}
                </div>
            </div>

            <div className="mt-6 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                <Datatable
                    columns={BRANDS_COLUMNS}
                    data={rows}
                    loading={loading}
                    pagination={{ count: pagination.total, page: pagination.page, limit: pagination.limit }}
                    handlePageChange={handlePageChange}
                    handlePerRowsChange={handlePerRowsChange}
                    customNoData={<span className="text-sm text-muted">No brands yet.</span>}
                />
            </div>

            <BrandsFilterDrawer
                open={filterOpen}
                filters={filters}
                onClose={closeFilters}
                onApply={handleFilterChange} />
        </div>
    );
};

export default Brands;
